import * as types from '../constants/user';
import api from '../api';
import store from 'store';

export const fetchUserInfoStart = () => {
  return {
    type: types.FETCH_USER_INFO_START
  };
};

export const fetchUserInfoSuccess = (payload) => {
  store.set('user', payload);

  return {
    type: types.FETCH_USER_INFO_SUCCESS,
    payload
  };
};

export const fetchUserInfoFailure = (err) => {
  return {
    type: types.FETCH_USER_INFO_FAILURE,
    err
  };
};

export const fetchUserInfo = (cb) => (dispatch) => {
  dispatch(fetchUserInfoStart());

  api.get('api.php?cmd=info')
    .then(({ data }) => {
      const payload = data.data;
      dispatch(fetchUserInfoSuccess(payload))

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(fetchUserInfoFailure(err));
    })
};

export const setTableFieldsStart = () => {
  return {
    type: types.SET_TABLE_FIELDS_START
  };
};

export const setTableFieldsSuccess = (payload) => {
  return {
    type: types.SET_TABLE_FIELDS_SUCCESS,
    payload
  };
};

export const setTableFieldsFailure = (err) => {
  return {
    type: types.SET_TABLE_FIELDS_FAILURE,
    err
  };
};

export const setTableFields = (payload, cb) => (dispatch) => {
  dispatch(setTableFieldsStart());

  api.post('api.php?cmd=setTableFields', payload)
    .then(({ data }) => {
      dispatch(setTableFieldsSuccess(data));

      if (cb) {
        cb();
      }
    })
    .catch((err) => {
      dispatch(setTableFieldsFailure(err));
    });
};
